module.exports = __webpack_public_path__ + "img/slovakia.6a6bdc2b.png";